import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_staff/marketplace/sent-orders/$orderId/_layout/activities',
)({
  component: OrderActivities,
});

function OrderActivities() {
  return (
    <div className="p-12">
      {/* NOTE:<div>アクティビティログ（実装予定）</div> */}
    </div>
  );
}
